module.exports = __webpack_public_path__ + "static/anna-and-ellie-2-4eac80aaf44e32f1b583d267b07af285.jpg";